import {
  ESIGN_LIST,
  ESIGN_LIST_SUCCESS,
  ESIGN_LIST_FAILURE,
  ESIGN_DATA,
  ESIGN_DATA_SUCCESS,
  ESIGN_DATA_FAILURE,
  ESIGN_CREATE,
  ESIGN_CREATE_SUCCESS,
  ESIGN_CREATE_FAILURE,
  ESIGN_UPDATE,
  ESIGN_UPDATE_SUCCESS,
  ESIGN_UPDATE_FAILURE,
  ESIGN_DOCUMENT_UPLOAD,
  ESIGN_DOCUMENT_UPLOAD_SUCCESS,
  ESIGN_DOCUMENT_UPLOAD_FAILURE,
  ESIGN_SEND,
  ESIGN_SEND_SUCCESS,
  ESIGN_SEND_FAILURE,
  ESIGN_VOID,
  ESIGN_VOID_SUCCESS,
  ESIGN_VOID_FAILURE,
  ESIGN_DOWNLOAD,
  ESIGN_DOWNLOAD_SUCCESS,
  ESIGN_DOWNLOAD_FAILURE,
  ESIGN_DELETE,
  ESIGN_DELETE_SUCCESS,
  ESIGN_DELETE_FAILURE,
} from "./actionType";

// List envelopes
export const listESign = () => {
  return {
    type: ESIGN_LIST,
  };
};

export const listESignSuccess = (esignList) => {
  return {
    type: ESIGN_LIST_SUCCESS,
    payload: esignList,
  };
};

export const listESignFailure = (error) => {
  return {
    type: ESIGN_LIST_FAILURE,
    payload: error,
  };
};

// Read one envelope (full nested bundle) - payload = { id }
export const getESignData = (data) => {
  return {
    type: ESIGN_DATA,
    payload: data,
  };
};

export const getESignDataSuccess = (esign) => {
  return {
    type: ESIGN_DATA_SUCCESS,
    payload: esign,
  };
};

export const getESignDataFailure = (error) => {
  return {
    type: ESIGN_DATA_FAILURE,
    payload: error,
  };
};

// Create draft (with nested recipient/document/field lists)
export const createESign = (esign) => {
  return {
    type: ESIGN_CREATE,
    payload: esign,
  };
};

export const createESignSuccess = (esign) => {
  return {
    type: ESIGN_CREATE_SUCCESS,
    payload: esign,
  };
};

export const createESignFailure = (error) => {
  return {
    type: ESIGN_CREATE_FAILURE,
    payload: error,
  };
};

// Update draft
export const updateESign = (esign) => {
  return {
    type: ESIGN_UPDATE,
    payload: esign,
  };
};

export const updateESignSuccess = (esign) => {
  return {
    type: ESIGN_UPDATE_SUCCESS,
    payload: esign,
  };
};

export const updateESignFailure = (error) => {
  return {
    type: ESIGN_UPDATE_FAILURE,
    payload: error,
  };
};

// Upload a base64 PDF document into an envelope
export const uploadESignDocument = (upload) => {
  return {
    type: ESIGN_DOCUMENT_UPLOAD,
    payload: upload,
  };
};

export const uploadESignDocumentSuccess = (document) => {
  return {
    type: ESIGN_DOCUMENT_UPLOAD_SUCCESS,
    payload: document,
  };
};

export const uploadESignDocumentFailure = (error) => {
  return {
    type: ESIGN_DOCUMENT_UPLOAD_FAILURE,
    payload: error,
  };
};

// Send (issue signing links + emails) - payload = { id }
export const sendESign = (data) => {
  return {
    type: ESIGN_SEND,
    payload: data,
  };
};

export const sendESignSuccess = (esign) => {
  return {
    type: ESIGN_SEND_SUCCESS,
    payload: esign,
  };
};

export const sendESignFailure = (error) => {
  return {
    type: ESIGN_SEND_FAILURE,
    payload: error,
  };
};

// Void - payload = { Id, VoidedReason }
export const voidESign = (data) => {
  return {
    type: ESIGN_VOID,
    payload: data,
  };
};

export const voidESignSuccess = (esign) => {
  return {
    type: ESIGN_VOID_SUCCESS,
    payload: esign,
  };
};

export const voidESignFailure = (error) => {
  return {
    type: ESIGN_VOID_FAILURE,
    payload: error,
  };
};

// Download the completed signed PDF - payload = { id }
export const downloadESign = (data) => {
  return {
    type: ESIGN_DOWNLOAD,
    payload: data,
  };
};

export const downloadESignSuccess = (download) => {
  return {
    type: ESIGN_DOWNLOAD_SUCCESS,
    payload: download,
  };
};

export const downloadESignFailure = (error) => {
  return {
    type: ESIGN_DOWNLOAD_FAILURE,
    payload: error,
  };
};

// Delete - payload = [Id, ...]
export const deleteESign = (ids) => {
  return {
    type: ESIGN_DELETE,
    payload: ids,
  };
};

export const deleteESignSuccess = (ids) => {
  return {
    type: ESIGN_DELETE_SUCCESS,
    payload: ids,
  };
};

export const deleteESignFailure = (error) => {
  return {
    type: ESIGN_DELETE_FAILURE,
    payload: error,
  };
};
